/*
 * 营业时间段配置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-08-02 11:58:47
 */

const api = {
	listShopCanteenHours: '/shop/canteen/listShopCanteenHours',
	openFlagShopCanteenHours: '/shop/canteen/openFlagShopCanteenHours',
	listCommoCategory: '/shop/canteen/listCommoCategoryByShopNo',
	updateShopCanteenHours: '/shop/canteen/updateShopCanteenHours'
};

const routes = {
	'/commodity-time': '营业时间段管理'
};

export {
	api,
	routes,
};
